import React from "react";
import { CardTitle } from "reactstrap";
import { Icon, TooltipComponent } from "../../../Component";
import { BarChart } from "../../charts/default/Charts";

const SaleRevenue = ({ thisMonth, thisWeek, monthChange, weekChange, barChartData }) => {
  const monthPct = monthChange !== undefined ? Math.abs(monthChange).toFixed(2) : null;
  const weekPct  = weekChange  !== undefined ? Math.abs(weekChange).toFixed(2)  : null;

  return (
    <React.Fragment>
      <div className="card-title-group align-start mb-2">
        <CardTitle>
          <h6 className="title">Sales Revenue</h6>
          <p>In last 30 days revenue from orders.</p>
        </CardTitle>
        <div className="card-tools">
          <TooltipComponent
            icon="help-fill"
            iconClass="card-hint"
            direction="left"
            id="tooltip-1"
            text="Revenue from orders"
          />
        </div>
      </div>
      <div className="align-end gy-3 gx-5 flex-wrap flex-md-nowrap flex-lg-wrap flex-xxl-nowrap">
        <div className="nk-sale-data-group flex-md-nowrap g-4">
          <div className="nk-sale-data">
            <span className="amount">
              {thisMonth !== undefined ? `₹ ${Number(thisMonth).toLocaleString("en-IN")}` : "Loading..."}{" "}
              {monthPct !== null && (
                <span className={`change ${monthChange >= 0 ? "up text-success" : "down text-danger"}`}>
                  <Icon name={monthChange >= 0 ? "arrow-long-up" : "arrow-long-down"} />
                  {monthPct}%
                </span>
              )}
            </span>
            <span className="sub-title">This Month</span>
          </div>
          <div className="nk-sale-data">
            <span className="amount">
              {thisWeek !== undefined ? `₹ ${Number(thisWeek).toLocaleString("en-IN")}` : "Loading..."}{" "}
              {weekPct !== null && (
                <span className={`change ${weekChange >= 0 ? "up text-success" : "down text-danger"}`}>
                  <Icon name={weekChange >= 0 ? "arrow-long-up" : "arrow-long-down"} />
                  {weekPct}%
                </span>
              )}
            </span>
            <span className="sub-title">This Week</span>
          </div>
        </div>
        <div className="nk-sales-ck sales-revenue">
          <BarChart sales chartData={barChartData} />
        </div>
      </div>
    </React.Fragment>
  );
};
export default SaleRevenue;
